import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoJobHistories from '@/components/formats/RirekishoParts/AutoJobHistories.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoHistoriesApi } from '@/composables/format-edit/useRirekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoJobHistoryCard',
  props: {
    currentCardId: null,
    formatId: null,
    basicData: null,
    previewErrors: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
  basicData: BasicData
  previewErrors: Record<string, string>
};

const descriptionMaxLength = 80



// 書式によって学歴・職歴は 1 画面へ統合される（カード定義の `sections`）
const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  setJobHistories,
  resetJobHistories,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  activateHistoryItem
} = useRirekishoHistoriesApi()

const jobResetVisible = ref(false)

return { __sfc: true,descriptionMaxLength, props, isSection, formatData, activeHistoryItem, setJobHistories, resetJobHistories, addJobHistory, deleteJobHistory, moveJobHistory, activateHistoryItem, jobResetVisible, HistoryItem, AutoJobHistories, NewRirekishoResetDialog }
}

})